import TextBrandSVG from '../resources/AcockBrandLogo.svg';

export default function TextBrand({ className }: any) {
  return (
    <img src={TextBrandSVG} alt='TextBrandLogo' />
  );
}
